import { AdminTopbar } from "@/components/admin/AdminLayout";
import { ModulePanel, DataTable, EditorialStatusBadge } from "@/components/admin/AdminPrimitives";
import { ARTICLES } from "@/lib/mock-data";
import { useI18n } from "@/lib/i18n";

const STATUSES = ["En attente", "Rendu", "Prêt", "Publié"];

function Avatars() {
  const { t } = useI18n();
  return (
    <>
      <AdminTopbar title={t("admin.avatars.title")} subtitle={t("admin.avatars.subtitle")} />
      <div className="flex-1 overflow-y-auto p-6 space-y-6">
        <ModulePanel title={t("admin.avatars.queue")} description={t("admin.avatars.queueDesc")}>
          <DataTable
            columns={[
              t("admin.avatars.col.content"),
              t("admin.avatars.col.language"),
              t("admin.avatars.col.voice"),
              t("admin.common.col.status"),
              t("admin.avatars.col.audioOnly"),
            ]}
            rows={ARTICLES.filter((a) => a.hasAvatarVideo).map((a, i) => [
              <span className="line-clamp-1 font-medium text-foreground">{a.title.fr}</span>,
              <span className="font-mono text-xs uppercase">{a.availableLanguages[0]}</span>,
              ["Voix A", "Voix B", "Voix C"][i % 3],
              <EditorialStatusBadge status={STATUSES[i % STATUSES.length]} />,
              i % 2 ? t("admin.avatars.yes") : t("admin.avatars.no"),
            ])}
          />
        </ModulePanel>
      </div>
    </>
  );
}

export default Avatars;
